<script setup>
    import {onMounted, ref} from "vue";
    import {storeToRefs} from "pinia";
    import {programStore} from "@pinia/program-store";
    import {updateLoading} from "@util/api";
    import {locationsAndMarkers} from "@util/map";

    const store = programStore();
    const {trialsSelected} = storeToRefs(store)

    const {apiUrl, postId} = TRIAL;
    const {filter, trials,} = PROGRAM;
    const {defaultCoords} = LOC?.mapSettings || {};
    const lat = parseFloat(defaultCoords?.latitude)
    const lng = parseFloat(defaultCoords?.longitude)
    const {viewAll, viewLink} = filter?.settings;

    const mapAllTrials = trials.map(trial => trial.id)

    /**
     * Checks off all the filter options minus the View all
     */
    const checkAllTrials = () => {
        const allCheckBoxes = document.querySelectorAll('.trial-filters__trial input')
        allCheckBoxes.forEach(elm => elm.checked = true)
    }

    /**
     * Adds the mapAllTrials to the trialsSelected state and query
     * @returns {*|void}
     */
    const addAllTrials = () => (
        checkAllTrials() && store.$patch({
            trialsSelected: mapAllTrials,
            query: {
                ...store.query,
                trials: mapAllTrials
            }
        })
    )

    /**
     * Removes the trials to the trialsSelected state and query
     */
    const removeAllTrials = () => (
        store.$patch({
            trialsSelected: [],
            query: {
                ...store.query,
                trials: []
            }
        })
    )

    /**
     * Handles the filtering of the checkboxes for the filter items
     *
     * @param {String} id The NCT ID of the selected item
     */
    const toggleTrial = (id) => {
        updateLoading(store, true)
        const allCheckbox = document.getElementById('all-trials')

        // If the View All is selected
        if (id === 0) {
            addAllTrials()
            allCheckbox.checked = true
        } else {
            // Check if this item is selected or not
            const isChecked = document.getElementById(`trial-filter-${id}`)
            allCheckbox.checked = false

            // Add the item to the store state for searching
            if (isChecked?.checked) {
                // If the trialsSelected is full, reset its state
                (trialsSelected.value.length === trials.length) && removeAllTrials()
                store.addTrial(id)
            } else {
                // Remove the item from the store state
                store.removeTrialByValue(id)

                // If it's the last item, select all again
                if (trialsSelected.value.length === 0) {
                    addAllTrials()
                    allCheckbox.checked = true
                }
            }
        }

        // Fetch our locations and setup the markers
        locationsAndMarkers(apiUrl, store.query)
            .then(({locations, markers}) => (locations && markers) && store.$patch({locations, markers}))
            .finally(() => updateLoading(store, false))
    }

    onMounted(() => trials.length && addAllTrials())

</script>

<template>
    <div class="trial-filters row">
        <div
            v-if="viewAll"
            class="trial-filters__all col-3">
            <input
                id="all-trials"
                name="all-trials"
                type="checkbox"
                value="all"
                :checked="trialsSelected.length === 0 || trialsSelected.length === trials.length"
                @click="toggleTrial(0)"
            />
            <label
                for="all-trials"
                v-html="viewAll"
            />
        </div>
        <div
            v-if="trials.length"
            v-for="({id, permalink, title, content}) in trials"
            :key="id"
            class="trial-filters__trial col-3"
        >
            <input
                :id="`trial-filter-${id}`"
                :name="`trial-${id}`"
                type="checkbox"
                :value="id"
                :checked="trialsSelected.includes(id) && !trialsSelected.length === trials.length"
                @click="toggleTrial(id)"
            />
            <label
                :for="`trial-filter-${id}`"
                v-html="title"
            />
            <div
                v-if="content"
                class="trial-filters__trial-content"
            >
                <p v-html="content" />
            </div>
            <div
                v-if="permalink"
                class="trial-filters__trial-link"
            >
                <a
                    :href="permalink"
                    v-html="viewLink"
                />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Checkbox Filter"
    }
</script>

<style scoped lang="scss">

</style>
